<div *ngIf="getPopOverData() === 'step1'" class="password-tooltip-title" [innerHTML] = "'ACCOUNT_CREATION.ACCOUNT_INFOBUBBLE_TITLE' | translate"></div>
<img (click)="closeTooltip()" src="../../../assets/img/close-password-tooltip.png">
<div *ngIf="getPopOverData() === 'step1'" [innerHTML] = "'ACCOUNT_CREATION.ACCOUNT_INFOBUBBLE_BODY' | translate"></div>
<div *ngIf="getPopOverData() === 'step2'" class="password-tooltip-title" [innerHTML] = "'ACCOUNT_CREATION.PARENT_PASSWORD_INFO_TITLE' | translate"></div>
<img (click)="closeTooltip()" src="../../../assets/img/close-password-tooltip.png">
<div *ngIf="getPopOverData() === 'step2'" [innerHTML] = "'ACCOUNT_CREATION.PARENT_PASSWORD_INFO_DESCRIPTION' | translate"></div>
<div *ngIf="getPopOverData() === 'step2-numeroabo'" class="password-tooltip-title" [innerHTML] = "'ACCOUNT_CREATION.SUBSCRIPTION_NUMBER_INFO_TITLE' | translate"></div>
<img (click)="closeTooltip()" src="/../../assets/img/close-password-tooltip.png">
<div *ngIf="getPopOverData() === 'step2-numeroabo'" [innerHTML] = "'ACCOUNT_CREATION.SUBSCRIPTION_NUMBER_INFO_DESCRIPTION' | translate"></div>
<div *ngIf="getPopOverData() === 'step3-promocode'" class="password-tooltip-title">{{'ACCOUNT_CREATION.PROMO_CODE_INFO_TITLE' | translate}}</div>
<div *ngIf="getPopOverData() === 'step3-promocode'" [innerHTML] = "'ACCOUNT.PROFILE_CREATOR.COUPON_INFOBUBBLE' | translate"></div>
<img (click)="closeTooltip()" src="../../../assets/img/close-password-tooltip.png">
<div *ngIf="getPopOverData() === 'home'">
	<div class="title">
    <span>Fonctionnalité en cours</span>
    <img (click)="closeTooltip()" src="../../../assets/img/close-feature-tooltip.png">
	</div>
	<div class="content">Cette fonctionnalité est en cours de développement et sera disponible très bientôt.</div>
	<div class="content-button">
    <ion-button (click)="closeTooltip()" class="createuser">OK</ion-button>
  </div>
</div>
